import { makeStyles } from "@material-ui/core";

export const useTitleStyle = makeStyles((theme) => ({
    title: {
        fontSize: 16,
        fontWeight: 500,
        color: "#2B2E30",
    },
}));
